export const baseUrl = '/api';
export const urls = {
    singIn: `/auth/local`,
    currentUser: `/users/me`,
    users: `/users`,
    register: `/auth/local/register`,
    cities: '/cities',
    filials: '/points',
    zone: '/zones',
    payments: '/payments',
    tags: '/tags',
    orders: '/orders',
    archive: '/archive',
    settings: '/settings',
    promocodes: '/promocodes',
    cashback: '/cashback',
    chanels: '/chanels',
    messages: '/messages',
    ratings: '/ratings',
    counter: '/counter',
    statistics: '/statistics',
    news: '/news',
    documentation: '/documentation',
    sliders: '/sliders',
    ips: '/blockedips',
    yookassa: '/yookassas',
    goods: '/goods',
    rawmaterials: '/rawmaterials',
    rawmaterialsinventories: '/rawmaterialsinventories',
    recipes: '/recipes',
    inventoryforms: '/inventoryforms',
    invoiceforms: '/invoiceforms',
    suppliers: '/suppliers',
    writeoffs: '/writeoffs',
    writeoffreasons: '/writeoffreasons',
    categories: '/categories',
    productscategories: 'productscategories',
    regionprices: '/regionprices',
    modifications: '/modifications',
    cashbacklogs: '/cashbacklogs',
    updateGoodsPrices: '/updateGoodsPrices',
    pointsLogs: '/pointsLogs',
    phonecodes: '/phonecodes',
    yumaposgoodsmap: '/yumaposgoodmaps',
    promotion: '/promotions',
    blockedPhones: '/blockedphones',
    ordergoods: '/ordergoods',
    aggregators: '/aggregators',
    kuper: '/kuper',
    articlesCash: '/articlescashes',
    articlesExpenditures: '/articlesotherexpenditures',
    workingShift: '/workingshifts',
    otherExpenditures: '/otherexpenditures',
    devices: '/devices',
    plannedRevenues: '/plannedrevenues',
    sources: '/sources',
    autoConsumptions: '/automaticconsumptions',
    webhooks: '/webhooks',
    wages: '/wages',
    articlesCashCategories: '/categoriesarticlescashes',
    revenues: '/revenues',
    revenuesstaffs: '/revenuesstaffs',
    staff: '/staff',
    blockedOrders: '/blockedorders',
    incomestatements: '/incomestatements',
    commissions: '/commissions',
    groupsgoods: '/groupgoods',
};

export const roleId = {
    client: 1,
    public: 2,
    manager: 3,
    admin: 4,
    coordinator: 5,
    operator: 7,
    cashier: 8,
    commodityExpert: 9,
    accountant: 10,
    marketingSpecialist: 11,
    regionalDirector: 12,
    chiefCommoditySpecialist: 13,
    chiefAccountant: 14,
    chiefMarketingSpecialist: 15,
    directorCC: 16,
    aggregator: 17,
    courier: 18,
    qualityControlManager: 19,
    operationDirector: 20,
};

export const optionsRole = [
    { value: roleId.operator, label: 'Оператор' },
    { value: roleId.coordinator, label: 'Координатор' },
    { value: roleId.directorCC, label: 'Руководитель КЦ' },
    { value: roleId.cashier, label: 'Кассир' },
    { value: roleId.courier, label: 'Курьер' },
    { value: roleId.manager, label: 'Управляющий' },
    { value: roleId.commodityExpert, label: 'Товаровед' },
    { value: roleId.accountant, label: 'Бухгалтер' },
    { value: roleId.marketingSpecialist, label: 'Маркетолог' },
    { value: roleId.qualityControlManager, label: 'Менеджер контроля качества'},
    { value: roleId.regionalDirector, label: 'Региональный директор' },
    { value: roleId.operationDirector, label: 'Операционный директор' },
    { value: roleId.chiefCommoditySpecialist, label: 'Главный товаровед' },
    { value: roleId.chiefAccountant, label: 'Главный бухгалтер' },
    { value: roleId.chiefMarketingSpecialist, label: 'Руководитель отдела маркетинга' },
    { value: roleId.aggregator, label: 'Агрегатор' },
];

export const timeDelivery = {
    minDeliveryTime: 60,
    minSamTime: 20
};

export const optionsTransaction = [
    { value: 'cash', label: 'Наличные' },
    { value: 'noncash', label: 'Безнал.' },
    { value: 'all', label: 'Оба типа' },
];

export const optionsMovementCash = [
    { value: 'income', label: 'Внесение' },
    { value: 'expenditure', label: 'Изъятие' },
    { value: 'refund_revenue', label: 'Возврат выручки', notRender: true },
    { value: 'incasso', label: 'Инкассация', notRender: true },
];

export const multipliersVat = {
    none: 0,
    vat0: 0,
    vat10: 0.1,
    vat20: 0.2,
    vat5: 0.05,
    vat7: 0.07,
};

export const optionsVat = [
    { value: 'none', label: 'без НДС' },
    { value: 'goods', label: 'НДС по товарам'},
    { value: 'vat0', label: 'НДС по ставке 0%' },
    { value: 'vat10', label: 'НДС по ставке 10%' },
    { value: 'vat20', label: 'НДС по ставке 20%' },
    { value: 'vat5', label: 'НДС по ставке 5%' },
    { value: 'vat7', label: 'НДС по ставке 7%' },
];

export const optionsSno = [
    { value: 'osn', label: 'Общая СН' },
    { value: 'usnIncome', label: 'Упрощенная СН (доходы)' },
    { value: 'usnIncomeOutcome', label: 'Упрощенная СН (доходы минус расходы)' },
    { value: 'envd', label: 'Единый налог на вмененный доход' },
    { value: 'esn', label: 'Единый сельскохозяйственный налог' },
    { value: 'patent', label: 'Патентная СН' },
];

export const optionsMinDeliveryTime = [
    { value: 60, label: 60 },
    { value: 75, label: 75 },
    { value: 90, label: 90 },
    { value: 105, label: 105 },
    { value: 120, label: 120 },
];

export const optionsMinSamTime = [
    { value: 20, label: 20 },
    { value: 30, label: 30 },
    { value: 40, label: 40 },
    { value: 50, label: 50 },
    { value: 60, label: 60 },
];

export const xmlBackenHost = 'https://sushibox.one/api'; // TODO: Необходимо заменить на адрес в проде
export const operationType = {
    setBalance: 'setBalance',
    minusBalance: 'minusBalance',
}

export const sourcesPromo = ['siteAndApp', 'cc', 'cassa'];

export const sourcesTitlePromo = {
    cc: 'КЦ',
    cassa: 'Касса',
    siteAndApp: 'Сайт и приложение',
};

export const optionsStatus = [
    { value: 'new', label: 'Новый', renderRobovoiceStatus: true },
    { value: 'processing', label: 'В обработке', client: 'Новый', renderRobovoiceStatus: true },
    { value: 'not-confirmed', label: 'Не подтвержден', client: 'Новый', renderRobovoiceStatus: true },
    { value: 'confirmed', label: 'Подтвержден', client: 'Новый' },
    { value: 'cook', label: 'Готовится' },
    { value: 'cooked', label: 'Приготовлен' },
    { value: 'delivery', label: 'В пути' },
    { value: 'done', label: 'Выполнен' },
    { value: 'written-off', label: 'Списан', client: 'Отменен' },
    { value: 'cancel', label: 'Отменен' },
    { value: 'deferred', label: 'Отложенный', client: 'Новый' }
];

export const daysWeek = [
    { value: 1, label: 'Пн' },
    { value: 2, label: 'Вт' },
    { value: 3, label: 'Ср' },
    { value: 4, label: 'Чт' },
    { value: 5, label: 'Пт' },
    { value: 6, label: 'Сб' },
    { value: 0, label: 'Вс' },
];

export const defaultPlatforms = [
    { name: 'Яндекс', value: 'YE' },
    { name: 'Деливери', value: 'DC' },
    { name: 'Купер', value: 'SBM' },
];

export const postsIds = [
    { id: 1, label: 'Кассир', moreLabel: 'Кассиры' },
    { id: 2, label: 'Повар', moreLabel: 'Повара' },
    { id: 3, label: 'Кух. рабочий', moreLabel: 'Кух. рабочие' },
    { id: 4, label: 'Стажер', moreLabel: 'Стажеры' },
    { id: 5, label: 'Мастер чистоты', moreLabel: 'Мастера чистоты' },
    { id: 6, label: 'Управляющий', moreLabel: 'Управляющие' },
    { id: 7, label: 'Курьер', moreLabel: 'Курьеры' },
];